import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl, Validators, ValidationErrors } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { EditorBuildingFacade, UIFacade } from '../../../../facades';
import { BuildingsDataStoreFacade } from '../../../../../../buildings/facades';

@Component({
  selector: 'app-editor-building',
  templateUrl: './editor-building.component.html',
  styleUrls: ['./editor-building.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorBuildingComponent {
  public form: FormGroup;
  public isRequesting = false;
  public options$ = combineLatest([this.dataStoreFacade.partners$, this.dataStoreFacade.folders$, this.editorFacade.isReadOnly$]).pipe(
    map(([partners, folders, isReadOnly]) => {
      return {
        partners: partners.sort((a, b) => a.partnerDescr.localeCompare(b.partnerDescr)),
        folders: folders.sort((a, b) => a.folderName.localeCompare(b.folderName)),
        readOnly: isReadOnly,
      };
    })
  );

  constructor(
    public editorFacade: EditorBuildingFacade,
    private dataStoreFacade: BuildingsDataStoreFacade,
    private fb: FormBuilder,
    public uiFacade: UIFacade
  ) {
    this.form = this.fb.group({});
  }

  onSubmit() {
    this.isRequesting = true;
    if (!this.form.invalid) {
      this.uiFacade.showLoading();
      this.editorFacade.save(true).subscribe(
        (result) => {
          if (result.success) {
            // SAVE SUCESS
            this.form.markAsUntouched();
            this.form.markAsPristine();
            this.isRequesting = false;
            this.uiFacade.hideLoading();
          }
        },
        (err) => {
          this.uiFacade.hideLoading();
        }
      );
    }
  }
  onClose() {
    this.editorFacade.close();
  }
}
